import { useState } from 'react';
import { Button, Callout, Typography } from 'seagull';
import { useStoreActions } from "../../contexts";
import { PlaidMode, usePlaidState } from "../../hooks/usePlaidState";
import { Intent } from "../../infra/access-control";
import styles from "./ConnectPlaid.module.scss";
import { mapErrorToMessage } from "./errors";
import plaidLogo from "./plaid-logo-horizontal-RGB.png";

/** Renders a UI that starts connects a bank account via plaid. */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ConnectPlaid(props) {
  const {
    disabledReason,
    relationshipId,
    vendorId,
    customerId,
    onSuccess,
    doPaymentMethodAction
  } = props;
  const {
    logBI
  } = useStoreActions();
  const [errorMessage, setErrorMessage] = useState(null);
  const plaidLink = usePlaidState({
    mode: {
      type: PlaidMode.Customer,
      vendorId,
      customerId,
      relationshipId
    },
    onSuccess(action) {
      onSuccess(action, {
        type: 'add'
      });
    },
    onError(error) {
      setErrorMessage(mapErrorToMessage(error));
    }
  });
  function openPlaidLink() {
    logBI(10805);
    setErrorMessage(null);
    plaidLink.open();
  }
  return /*#__PURE__*/_jsxs("form", {
    "data-testid": "manage-payment-methods-connect-plaid-form",
    onSubmit: event => {
      event.preventDefault();
      doPaymentMethodAction(openPlaidLink);
    },
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "paragraph1",
      children: "Securely add your bank account via Plaid."
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph1",
      children: "Connect instantly using your bank credentials or using your routing and account numbers."
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.footer,
      children: [/*#__PURE__*/_jsx("img", {
        className: styles.plaidLogo,
        src: plaidLogo,
        alt: "Plaid logo"
      }), /*#__PURE__*/_jsx(Button, {
        type: "submit",
        size: "small",
        disabled: !!disabledReason,
        testId: "manage-payment-methods-connect-plaid",
        intent: Intent.AddPaymentMethod,
        tooltip: disabledReason ? {
          placement: 'top',
          title: /*#__PURE__*/_jsx("div", {
            "data-testid": "connect-plaid-disabled-reason",
            children: disabledReason
          })
        } : undefined,
        children: "Connect bank account"
      })]
    }), errorMessage && /*#__PURE__*/_jsx(Callout, {
      className: styles.error,
      intent: "error",
      testId: "manage-payment-methods-plaid-error",
      children: errorMessage
    })]
  });
}